import { useSubjectPropertyFieldBindings } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyFieldBindings";
import { useSubjectPropertyFieldVisibility } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyFieldVisibility";
export const subjectPropertyPageBindingsAndVisibilities = () => {
  const {
    propertyDetailsPurchasePrice,
    propertyDetailsOccupancy,
    propertyDetailsPurchaseDate,
    propertyDetailsLivingSpace,
    propertyDetailsAppraisedValue,
    propertyDetailsAppraisalDate,
    propertyDetailsBlock,
    propertyDetailsConcTownship,
    propertyDetailsEstimatedValue,
    propertyDetailsLot,
    propertyDetailsMlsListing,
    propertyDetailsMonthlyIncome,
    propertyDetailsPropertyValueIndex,
    propertyDetailsRentalProperty,
    propertyStylePropertyStyle,
    propertyStylePropertyType,
    propertyStyleGarageSize,
    propertyStyleConstructionType,
    propertyStyleEnvironmentalHazard,
    propertyStyleHeat,
    propertyStyleLotSize,
    propertyStyleGarageStyle,
    propertyStyleLotSizeType,
    propertyStyleNumberOfUnits,
    propertyStyleSewageInfo,
    propertyStyleStructureAge,
    propertyStyleTenure,
    propertyStyleWaterInfo,
    propertyAddress,
    propertyCostsFeesIncludeHeat,
    propertyCostsHeating,
    propertyCostsHydro,
    propertyCostsIncludeInTds,
    propertyCostsInsurance,
    propertyCostsInterest,
    propertyCostsMaintenanceFees,
    propertyCostsManagement,
    propertyCostsOthers,
    propertyCostsPercOfTotalMaintFees,
    propertyCostsPropertyTaxes,
    propertyCostsRentalIncomeOptions,
    propertyCostsRentalIncomeOptionsPercent,
    propertyCostsRepairs,
    propertyCostsTaxResponsible,
    propertyCostsTaxYear,
    subjectProperty
  } = useSubjectPropertyFieldBindings();
  const {
    propertyDetailsPurchasePriceVisible,
    propertyDetailsOccupancyVisible,
    propertyDetailsPurchaseDateVisible,
    propertyDetailsLivingSpaceVisible,
    propertyDetailsAppraisedValueVisible,
    propertyDetailsAppraisalDateVisible,
    propertyDetailsBlockVisible,
    propertyDetailsConcTownshipVisible,
    propertyDetailsEstimatedValueVisible,
    propertyDetailsLotVisible,
    propertyDetailsMlsListingVisible,
    propertyDetailsMonthlyIncomeVisible,
    propertyDetailsPropertyValueIndexVisible,
    propertyDetailsRentalPropertyVisible,
    propertyAddressVisible,
    propertyStylePropertyStyleVisible,
    propertyStyleConstructionTypeVisible,
    propertyStyleEnvironmentalHazardVisible,
    propertyStyleHeatVisible,
    propertyStyleLotSizeVisible,
    propertyStyleGarageStyleVisible,
    propertyStyleLotSizeTypeVisible,
    propertyStyleNumberOfUnitsVisible,
    propertyStyleSewageInfoVisible,
    propertyStyleStructureAgeVisible,
    propertyStyleTenureVisible,
    propertyStyleWaterInfoVisible,
    propertyStylePropertyTypeVisible,
    propertyStyleGarageSizeVisible,
    propertyCostsFeesIncludeHeatVisible,
    propertyCostsHeatingVisible,
    propertyCostsHydroVisible,
    propertyCostsIncludeInTdsVisible,
    propertyCostsInsuranceVisible,
    propertyCostsInterestVisible,
    propertyCostsMaintenanceFeesVisible,
    propertyCostsManagementVisible,
    propertyCostsOthersVisible,
    propertyCostsPercOfTotalMaintFeesVisible,
    propertyCostsPropertyTaxesVisible,
    propertyCostsRentalIncomeOptionsVisible,
    propertyCostsRentalIncomeOptionsPercentVisible,
    propertyCostsRepairsVisible,
    propertyCostsTaxResponsibleVisible,
    propertyCostsTaxYearVisible,
    existingMortgagesIsVisible
  } = useSubjectPropertyFieldVisibility();
  return {
    bindings: {
      propertyDetailsPurchasePrice,
      propertyDetailsOccupancy,
      propertyDetailsPurchaseDate,
      propertyDetailsLivingSpace,
      propertyDetailsAppraisedValue,
      propertyDetailsAppraisalDate,
      propertyDetailsBlock,
      propertyDetailsConcTownship,
      propertyDetailsEstimatedValue,
      propertyDetailsLot,
      propertyDetailsMlsListing,
      propertyDetailsMonthlyIncome,
      propertyDetailsPropertyValueIndex,
      propertyDetailsRentalProperty,
      propertyStylePropertyStyle,
      propertyStylePropertyType,
      propertyStyleGarageSize,
      propertyStyleConstructionType,
      propertyStyleEnvironmentalHazard,
      propertyStyleHeat,
      propertyStyleLotSize,
      propertyStyleGarageStyle,
      propertyStyleLotSizeType,
      propertyStyleNumberOfUnits,
      propertyStyleSewageInfo,
      propertyStyleStructureAge,
      propertyStyleTenure,
      propertyStyleWaterInfo,
      propertyAddress,
      propertyCostsFeesIncludeHeat,
      propertyCostsHeating,
      propertyCostsHydro,
      propertyCostsIncludeInTds,
      propertyCostsInsurance,
      propertyCostsInterest,
      propertyCostsMaintenanceFees,
      propertyCostsManagement,
      propertyCostsOthers,
      propertyCostsPercOfTotalMaintFees,
      propertyCostsPropertyTaxes,
      propertyCostsRentalIncomeOptions,
      propertyCostsRentalIncomeOptionsPercent,
      propertyCostsRepairs,
      propertyCostsTaxResponsible,
      propertyCostsTaxYear,
      subjectProperty
    },
    visibilities: {
      propertyDetailsPurchasePriceVisible,
      propertyDetailsOccupancyVisible,
      propertyDetailsPurchaseDateVisible,
      propertyDetailsLivingSpaceVisible,
      propertyDetailsAppraisedValueVisible,
      propertyDetailsAppraisalDateVisible,
      propertyDetailsBlockVisible,
      propertyDetailsConcTownshipVisible,
      propertyDetailsEstimatedValueVisible,
      propertyDetailsLotVisible,
      propertyDetailsMlsListingVisible,
      propertyDetailsMonthlyIncomeVisible,
      propertyDetailsPropertyValueIndexVisible,
      propertyDetailsRentalPropertyVisible,
      propertyAddressVisible,
      propertyStylePropertyStyleVisible,
      propertyStyleConstructionTypeVisible,
      propertyStyleEnvironmentalHazardVisible,
      propertyStyleHeatVisible,
      propertyStyleLotSizeVisible,
      propertyStyleGarageStyleVisible,
      propertyStyleLotSizeTypeVisible,
      propertyStyleNumberOfUnitsVisible,
      propertyStyleSewageInfoVisible,
      propertyStyleStructureAgeVisible,
      propertyStyleTenureVisible,
      propertyStyleWaterInfoVisible,
      propertyStylePropertyTypeVisible,
      propertyStyleGarageSizeVisible,
      propertyCostsFeesIncludeHeatVisible,
      propertyCostsHeatingVisible,
      propertyCostsHydroVisible,
      propertyCostsIncludeInTdsVisible,
      propertyCostsInsuranceVisible,
      propertyCostsInterestVisible,
      propertyCostsMaintenanceFeesVisible,
      propertyCostsManagementVisible,
      propertyCostsOthersVisible,
      propertyCostsPercOfTotalMaintFeesVisible,
      propertyCostsPropertyTaxesVisible,
      propertyCostsRentalIncomeOptionsVisible,
      propertyCostsRentalIncomeOptionsPercentVisible,
      propertyCostsRepairsVisible,
      propertyCostsTaxResponsibleVisible,
      propertyCostsTaxYearVisible,
      existingMortgagesIsVisible
    }
  };
};